/* RødGlød premium PDP interactions (Claude). Vanilla, no deps.
   Idempotent: safe to include from multiple sections (dataset guards),
   and re-initializes on shopify:section:load so the theme editor works. */
(function () {
  function initFaq(root) {
    root.querySelectorAll('.rgp-faq__q').forEach(function (btn) {
      if (btn.dataset.rgpBound) return;
      btn.dataset.rgpBound = '1';
      btn.addEventListener('click', function () {
        var panel = btn.parentElement.querySelector('.rgp-faq__a');
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (panel) panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
      });
    });
  }

  function initHotspots(root) {
    root.querySelectorAll('[data-rgp-hot]').forEach(function (hot) {
      if (hot.dataset.rgpBound) return;
      hot.dataset.rgpBound = '1';
      var pts = hot.querySelectorAll('.rgp-hot__pt');
      var lis = hot.querySelectorAll('.rgp-hot__li');
      function activate(idx) {
        pts.forEach(function (p, i) { p.setAttribute('aria-expanded', String(i === idx)); });
        lis.forEach(function (l, i) { l.setAttribute('data-active', String(i === idx)); });
      }
      pts.forEach(function (p, i) { p.addEventListener('click', function () { activate(i); }); });
      lis.forEach(function (l, i) {
        l.addEventListener('mouseenter', function () { activate(i); });
        l.addEventListener('click', function () { activate(i); });
      });
      if (pts.length) activate(0);
    });
  }

  function initTimeline(root) {
    var nodes = root.querySelectorAll('.rgp-tl__node');
    if (!nodes.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('rgp-tl__node--on'); });
      }, { threshold: 0.4 });
      nodes.forEach(function (n) { if (!n.dataset.rgpBound) { n.dataset.rgpBound = '1'; io.observe(n); } });
    } else {
      nodes.forEach(function (n) { n.classList.add('rgp-tl__node--on'); });
    }
  }

  function initVideo(root) {
    root.querySelectorAll('.rgp-video__play, .rgs3-play').forEach(function (btn) {
      if (btn.dataset.rgpBound) return;
      btn.dataset.rgpBound = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.rgp-video') || btn.closest('.rgs3-video');
        var embed = wrap && wrap.getAttribute('data-embed');
        if (wrap && embed) wrap.innerHTML = embed;
      });
    });
  }

  function initAll(root) {
    root = root && root.querySelectorAll ? root : document;
    initFaq(root);
    initHotspots(root);
    initTimeline(root);
    initVideo(root);
  }

  if (document.readyState !== 'loading') initAll(document);
  else document.addEventListener('DOMContentLoaded', function () { initAll(document); });

  /* Theme editor: sections re-render dynamically */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* Mobile product gallery: on-image segmented position indicator (Claude) */
(function () {
  function initGalleryIndicator(root) {
    root = root && root.querySelectorAll ? root : document;
    root.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      var slider = wrap.querySelector('.product__media-list');
      if (!slider || slider.dataset.rgInd) return;
      var items = slider.querySelectorAll('.product__media-item');
      if (items.length < 2) return;
      slider.dataset.rgInd = '1';
      var ind = document.createElement('div');
      ind.className = 'rg-media-ind';
      ind.setAttribute('aria-hidden', 'true');
      for (var i = 0; i < items.length; i++) { var s = document.createElement('span'); s.className = 'rg-media-seg'; ind.appendChild(s); }
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      wrap.appendChild(ind);
      var segs = ind.querySelectorAll('.rg-media-seg');
      function setActive(idx) { idx = Math.max(0, Math.min(segs.length - 1, idx)); for (var i = 0; i < segs.length; i++) segs[i].classList.toggle('is-active', i === idx); }
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio >= 0.5) setActive(Array.prototype.indexOf.call(items, e.target)); });
        }, { root: slider, threshold: [0.5, 0.75] });
        for (var k = 0; k < items.length; k++) io.observe(items[k]);
      }
      slider.addEventListener('scroll', function () { setActive(Math.round(slider.scrollLeft / (slider.clientWidth || 1))); }, { passive: true });
      setActive(0);
    });
  }
  if (document.readyState !== 'loading') initGalleryIndicator(document);
  else document.addEventListener('DOMContentLoaded', function () { initGalleryIndicator(document); });
  document.addEventListener('shopify:section:load', function (e) { initGalleryIndicator(e.target); });
})();

/* Desktop PDP: vertically center the sticky media gallery (equal top/bottom padding when locked) */
(function () {
  function centerGallery() {
    var g = document.querySelector('media-gallery.product__column-sticky');
    if (!g) return;
    var root = document.documentElement;
    if (window.matchMedia('(max-width: 989px)').matches) { root.style.removeProperty('--rg-gallery-top'); return; }
    var top = Math.max(24, Math.round((window.innerHeight - g.offsetHeight) / 2));
    root.style.setProperty('--rg-gallery-top', top + 'px');
  }
  if (document.readyState !== 'loading') centerGallery();
  else document.addEventListener('DOMContentLoaded', centerGallery);
  window.addEventListener('load', centerGallery);
  window.addEventListener('resize', centerGallery, { passive: true });
  document.addEventListener('shopify:section:load', centerGallery);
})();
